import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const pricingList2Slice = createApi({
    reducerPath: "pricingList2",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://brand-logistics.demo.permute.in",
        prepareHeaders: (headers, { getState }) => {
            const token = localStorage.getItem("authToken");
            if (token) {
                headers.set("authorization", "Bearer " + token);
            }
            return headers;
        },
    }),
    refetchOnMountOrArgChange: true,
    endpoints: (builder) => ({
        pricingList2: builder.query({
            query: (data) => ({ url: "/order-management/api/v1/productpricing/list", params: data, method: "GET" }),
        }),
    }),
});

export const { usePricingList2Query } = pricingList2Slice;
